import type { ReactNode } from 'react'
import type React from 'react'

interface ClickableAreaProps {
  onClick: (e: React.MouseEvent<HTMLElement>) => void
  children: ReactNode
}

export function ClickableArea({ onClick, children }: ClickableAreaProps) {
  return (
    <div
      onClick={(e) => {
        e.stopPropagation()
        onClick(e)
      }}
      style={{
        width: '100%',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        cursor: 'pointer',
      }}
    >
      {children}
    </div>
  )
}
